module.exports = __webpack_public_path__ + "static/media/readysetgo.c8cf169b.mp3";